import script from "./BackLink.vue?vue&type=script&setup=true&lang=js"
export * from "./BackLink.vue?vue&type=script&setup=true&lang=js"

import "./BackLink.vue?vue&type=style&index=0&id=6576520d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6576520d"]])

export default __exports__